<template>
  <div class="flex items-center" :class="!!left || 'justify-center'">
    <p class=" font-bold text-blue-600">
      <b>{{ label }}</b>
    </p>
  </div>
</template>

<script>
export default {
  props: ["left","label"],
};
</script>